import store from "../../../store";
import yelo_export from './yelo_export.vue';

window.yelo_export =  new Vue({
    store,
    el: 'div#yelo_export',

    name : "yelo_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        yelo_export,
    }
});
